import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgScrollbarModule } from 'ngx-scrollbar';

import { CoreCommonModule } from '@xbaht/ui/core/common.module';
import { CoreMenusModule } from '@xbaht/ui/core/components/core-menus/core-menus.module';

import { VerticalMenuComponent } from './vertical-menu.component';

@NgModule({
  declarations: [VerticalMenuComponent],
  imports: [CoreMenusModule, CoreCommonModule, RouterModule, NgScrollbarModule],
  exports: [VerticalMenuComponent],
})
export class VerticalMenuModule {}
